import { axiosInstance } from "@/helpers"
import axios from "axios"

const getModule = {
  state: {
    data: [],
  },
  mutations: {
    setInvestmentData(state, data) {
      state.data = data
    },
  },
  actions: {
    setInvestmentData({ commit, state }) {
      if (state.data.length == 0) {
        axiosInstance()
          .get(process.env.VUE_APP_BACKEND_URL + "/private/investment/index", {
            headers: {
              Authorization: this.state.auth.token,
            },
          })
          .then((response) => {
            commit("setInvestmentData", response.data)
          })
      }
    },
  },
  getters: {
    allInvestment: (state) => state.data,
  },
}

export default getModule
